import axios from '@fs/zion-axios'
import { SG_BASE_URL, headers } from '../config'
import { errorCollector } from '../../utils/utils'

// Resource: https://sg32i0.familysearch.org/service/standards/place/ws/places/reps/164/names/en

/**
 * Request the name of a concept according to a language
 * @params conceptCode - the code for the place (i.e. 103979)
 * @params language - the language of the user (i.e. en)
 * @returns {Object} object in this format:
 * { "translation": "Birth Records" }
 */
export default async function getConceptName(conceptCode, language) {
  const url = `${SG_BASE_URL}/service/standards/cv/ws/cv/concepts/${conceptCode}?termType=OFFICIAL_PLURAL&accept-language=${language}`
  return axios
    .get(url, { headers })
    .then(({ data }) => {
      const {
        concept: {
          terms: [
            {
              translations: [translation],
            },
          ],
        },
      } = data
      return translation
    })
    .catch((err) => {
      errorCollector(err, null, {
        codeId: 55,
        status: err?.response?.status,
        responseBody: err?.response?.data,
      })
      throw new Error(err)
    })
}
